"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
const escapeRegExp_1 = __importDefault(require("lodash/escapeRegExp"));
const react_1 = __importDefault(require("react"));
function Highlight(props) {
    const { className, children, color, search = '' } = props;
    const exp = new RegExp((0, escapeRegExp_1.default)(search), 'gi');
    const style = color ? { color: color.main } : undefined;
    if (search === '' || !exp.test(children)) {
        return (react_1.default.createElement("span", { className: className, style: style }, children));
    }
    return (react_1.default.createElement("span", { className: className, style: style, dangerouslySetInnerHTML: {
            __html: children.replace(exp, match => '<mark>' + match + '</mark>'),
        } }));
}
exports.Highlight = Highlight;
exports.default = Highlight;
